import { debug } from "./debug";

/*------------------------------------*\
  #B64TOBLOBS

  Class gestion des b64toblobs
\*------------------------------------*/
class B64toblob {
  constructor(){}

  /*------------------------------------*\
    #INITIALISATION
  \*------------------------------------*/
  init = () => {
    if(debug.DEBUG) console.log('helpers/b64toblob.js');
  }

  get = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteArray = new Uint8Array(slice.length);
  
      for (let i = 0; i < slice.length; i++) {
        byteArray[i] = slice.charCodeAt(i);
      }
  
      byteArrays.push(byteArray);
    }
  
    return new Blob(byteArrays, { type: contentType });
  };
  
}
export const b64toblob = new B64toblob(); 
document.addEventListener("DOMContentLoaded", function() {
  b64toblob.init();
});